import http from '@/api/common'

export default {
  getStandardOpeningHours(tenantId) {
    return http.get(`openingHours/GetStandardOpeningHours?tenantId=${tenantId}`)
  },
  getHolidayOpeningHours(tenantId) {
    return http.get(`openingHours/GetHolidayOpeningHours?tenantId=${tenantId}`)
  },
  getStandardOpeningHoursForList() {
    return http.get('openingHours/StandardOpeningHoursForList')
  },
  getStandardOpeningHoursForId(id) {
    return http.get(`openingHours/StandardOpeningHoursForId?id=${id}`)
  },
  getHolidayOpeningHoursForId(id) {
    return http.get(`openingHours/HolidayOpeningHoursForId?id=${id}`)
  },
  getTenantDetails() {
    return http.get('openingHours/TenantDetails')
  },
  updateStandardOpeningHours(data) {
    return http.post('openingHours/UpdateStandardOpeningHours', data)
  },
  updateHolidayOpeningHours(data) {
    return http.post('openingHours/UpdateHolidayOpeningHours', data)
  },
  insertHolidayOpeningHours(data) {
    return http.post('openingHours/InsertHolidayOpeningHours', data)
  },
  deleteHolidaySchedule(data) {
    return http.post('openingHours/DeleteHolidayOpeningHours', data)
  },
  updateTenantSupportEmail(data) {
    return http.post('openingHours/UpdateTenantSupportEmail', data)
  },
  getOutOfHoursAuditLog(searchOptions) {
    return http.post('openingHours/GetAuditLog', searchOptions)
  }
}



// WEBPACK FOOTER //
// ./src/api/endpoints/openinghours.js